import moment from "moment"



const Footer = () => {
    return (
        <footer className="border-t border-gray-100 px-4 py-3">
            <p className="text-xs text-gray-400 text-center">
                &copy; {moment().format('YYYY')} MATRIZ MG — Todos os direitos reservados.
            </p>
        </footer>
    )
}

export default Footer
